<template>
    <sub-page class="m-addTheoryCourse">
        <!--<div slot="header">-->
        <!--<span>{{courseId ? $t('course.theoryCoursewareEdit') : $t('course.theoryCoursewareMake') }}</span>-->
        <!--<el-button class="btn-header" type="danger" size="small" @click="closeFn">-->
        <!--<i class="nucfont inuc-close"></i>-->
        <!--</el-button>-->
        <!--</div>-->
        <el-row :gutter="20" style="margin-top: -10px">
            <el-col :span="24">
                <el-steps :active="active" finish-status="success" simple>
                    <el-step :title="$t('course.addBaseInfo')" icon="el-icon-edit"
                             @click.native="on_click(0)"></el-step>
                    <el-step :title="$t('course.addChapter')" icon="el-icon-tickets"
                             @click.native="on_click(1)"></el-step>
                </el-steps>
            </el-col>
        </el-row>
        <!-- 第一步 -->
        <transition enter-active-class="animated fadeIn">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-width="$i18n.locale==='zh-CN'?'140px':'200px'"
                     class="course-form" v-if="active == 0">
                <el-row class="marBtm15" style="margin-top: 20px">
                    <el-col :span="8">
                        <el-form-item :label="$t('course.name')" prop="name">
                            <el-input v-model="ruleForm.name" :placeholder="$t('tip.courseName')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('c.knowledgePoint')" prop="knowledge">
                            <el-cascader
                                v-model="ruleForm.knowledge"
                                :options="knowledgeMenu['Theory']"
                                :props="cascadeProp"
                                :placeholder="$t('tip.knowledgePoint')"
                                :show-all-levels="false"
                                @change="knowledgeChange"
                                filterable
                            ></el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('c.operatorLevel')" prop="forLevel">
                            <el-select v-model="ruleForm.forLevel" collapse-tags :placeholder="$t('tip.operatorLevel')">
                                <el-option :label="item.value" :value="item.id" v-for="item in forLevelMenu"
                                           :key="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="marBtm15">
                    <el-col :span="8">
                        <el-form-item :label="$t('course.courseCover')">
                            <el-upload
                                class="avatar-uploader"
                                :action="imgUpload.api"
                                :data="imgUpload.params"
                                accept=".jpg,.jpeg,.bmp,.png"
                                name="upfile"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload"
                                :disabled="disableUploadCover"
                            >
                                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                <i class="el-icon-plus avatar-uploader-icon" :title="$t('course.addCover')" v-else></i>
                                <div class="mask" v-if="disableUploadCover">
                                    <i class="nucfont inuc-delete delete-cover" :title="$t('course.deleteCover')"
                                       @click="deleteCover"></i>
                                </div>
                                <div class="el-upload__tip" slot="tip">{{$t('course.coverTip', [2])}}</div>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="16">
                        <el-row class="marBtm15">
                            <el-col :span="12">
                                <el-form-item :label="$t('train.hour')" prop="hours">
                                    <el-input-number v-model="ruleForm.hours" controls-position="right" :step="1" :min="1"
                                                     :max="1000"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('train.credit')" prop="score">
                                    <el-input-number v-model="ruleForm.score" controls-position="right" :step="1" :min="1"
                                                     :max="1000"></el-input-number>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row class="marBtm15">
                            <el-col :span="23">
                                <el-form-item :label="$t('course.courseDesc')" prop="description">
                                    <el-input type="textarea"
                                              v-model="ruleForm.description"
                                              :autosize="{ minRows: 5}"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>

                </el-row>
                <div class="btn-group">
                    <el-button type="primary" @click="next('ruleForm')" style="padding: 14px 50px;font-size: 18px;">
                        {{$t('c.next')}}
                    </el-button>
                </div>
            </el-form>
        </transition>

        <!-- 第二步 -->
        <transition enter-active-class="animated fadeIn">
            <section id="content_form-p-2" role="tabpanel" aria-labelledby="content_form-h-2" class="body current"
                     aria-hidden="false" style="display: block; left: 0px;margin-top: 20px" v-if="active == 1">
                <div class="chapter-section-panel">
                    <div class="panel-heading">
                        <div class="course-file-icon">
                            <i class="nucfont inuc-folder-ppt"></i>
                        </div>
                        <p class="title">{{$t('course.curriculumSystem')}}</p>
                        <span class="chapter-add-tip">{{$t('course.addTip')}}</span>
                        <!-- 课程体系 -->
                    </div>
                    <div class="panel-body" id="chapterSection">
                        <ul class="drag-area" id="dragsort1">
                            <draggable v-model="chapters"
                                       :options="{handle:'.chapter-content',animation:20,filter:'.el-input',preventOnFilter:false}">
                                <li :class="['chapter-content',{'chapter-current':cItem.isCurrent}]"
                                    v-for="(cItem,cIndex) in chapters" :key="cIndex">
                                    <div class="chapter-section-header">
                                        <div class="header-input">
                                            <p class="num">{{cIndex + 1}}</p>
                                            <el-input :placeholder="$t('course.chapterTitle')" name="chapter-name"
                                                      v-model="cItem.name" size="small" maxLength="100"
                                                      @keydown.enter.native="addChapter(cIndex)">
                                            </el-input>
                                        </div>
                                        <div class="header-operate">
                                            <i class="nucfont inuc-exclamation-circle error-tip" v-if="isShowError(cItem)"></i>
                                            <i class="nucfont inuc-delete" v-if="chapters.length>1"
                                               @click="deleteChapter(cIndex)"></i>
                                            <i :class="['nucfont',[cItem.isCurrent?'inuc-arrow-down':'inuc-arrow-right']]"
                                               @click="clickChapterFold(cItem.isCurrent,cIndex)"></i>
                                        </div>
                                    </div>
                                    <div class="chapter-section" v-show="cItem.isCurrent">
                                        <ul class="drag-area" id="dragsort">
                                            <draggable v-model="cItem.sections"
                                                       :options="{handle:'.section-content',animation:20,filter:'.el-input',preventOnFilter:false}">

                                                <li :class="['section-content',{'section-current':sItem.isCurrent}]"
                                                    v-for="(sItem,sIndex) in cItem.sections" :key="sIndex">
                                                    <div class="chapter-section-header">
                                                        <div class="header-input section">
                                                            <div class="section-drag">
                                                                <i class="nucfont inuc-drag"></i>
                                                            </div>
                                                            <p class="num">{{(cIndex + 1) + '.' + (sIndex + 1)}}</p>
                                                            <el-input :placeholder="$t('course.sectionTitle')"
                                                                      name="section-name" maxLength="100" v-model="sItem.name"
                                                                      size="small"
                                                                      @keydown.enter.native="addSection(cIndex,sIndex)">
                                                            </el-input>
                                                        </div>
                                                        <div class="header-operate">
                                                            <i class="nucfont inuc-exclamation-circle error-tip"
                                                               v-if="isClickFinish && (sItem.resourceID == 0 || sItem.name == '')"
                                                               @click.stop="clickSecValidate"></i>
                                                            <i class="nucfont inuc-delete" v-if="cItem.sections.length > 1"
                                                               @click="deleteSection(cIndex, sIndex)"></i>
                                                            <i :class="['nucfont',[sItem.isCurrent ? 'inuc-arrow-down' : 'inuc-arrow-right']]"
                                                               @click="clickSectionFold(sItem.isCurrent, cIndex, sIndex)"></i>
                                                        </div>
                                                    </div>
                                                    <div class="section-content-type" v-show="sItem.isCurrent">
                                                        <div class="section-file-type" v-if="sItem.fileType == 0">
                                                            <div class="file-type" @click="sItem.fileType = 10">
                                                                <i class="nucfont inuc-upload-video"></i>
                                                                <p>{{$t('c.video')}}</p>
                                                            </div>
                                                            <div class="file-type" @click="sItem.fileType = 11">
                                                                <i class="nucfont inuc-yinpin"></i>
                                                                <p>{{$t('c.audio')}}</p>
                                                            </div>
                                                            <div class="file-type" @click="sItem.fileType = 12">
                                                                <i class="nucfont inuc-picture"></i>
                                                                <p>{{$t('c.image')}}</p>
                                                            </div>
                                                            <div class="file-type" @click="sItem.fileType = 8">
                                                                <i class="nucfont inuc-pdf-lib"></i>
                                                                <p>{{$t('c.document')}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="file-select" v-if="sItem.fileType > 0">
                                                            <div class="file-select-operate">
                                                                <el-button type="text" size="mini" @click="sItem.fileType = 0"
                                                                           :disabled="sItem.resourceID > 0 ||sItem.upFileID > 0 ">
                                                                    {{$t('c.back')}}
                                                                </el-button>
                                                                <el-button size="mini"
                                                                           @click="chooseRes(sItem.fileType,cIndex,sIndex)"
                                                                           :disabled="sItem.resourceID > 0 ||sItem.upFileID > 0 ">
                                                                    {{$t('course.resourceSelection')}}
                                                                </el-button>
                                                                <el-button size="mini"
                                                                           @click="uploadFiles(sItem.fileType,cIndex,sIndex)"
                                                                           :disabled="sItem.resourceID > 0 ||sItem.upFileID > 0 ">
                                                                    {{$t('course.fileUpload')}}
                                                                </el-button>
                                                            </div>
                                                            <div class="file-selected-wrap">
                                                                <div class="file-resource"
                                                                     v-if="sItem.resourceID > 0 ||sItem.upFileID > 0 ">
                                                                    <span class="delete-file" v-if="sItem.upFileID == 0">
                                                                        <i class="nucfont inuc-close" :title="$t('c.delete')" @click="deleteFile(sItem)"></i>
                                                                    </span>
                                                                    <div class="file-left" v-if="sItem.fileType == 12">
                                                                        <img :src="sItem.resURL" class="image">
                                                                    </div>
                                                                    <div class="file-left" v-if="sItem.fileType == 10">
                                                                        <img src="../../assets/images/course/video.png"
                                                                             class="image">
                                                                    </div>
                                                                    <div class="file-left" v-if="sItem.fileType == 11">
                                                                        <img src="../../assets/images/course/audio.png"
                                                                             class="image">
                                                                    </div>
                                                                    <div class="file-left"
                                                                         v-if="sItem.fileType == 8 && sItem.extension == '.pdf'">
                                                                        <img src="../../assets/images/document/pdf.png"
                                                                             class="image">
                                                                    </div>
                                                                    <div class="file-left"
                                                                         v-if="sItem.fileType == 8 && (sItem.extension == '.xls'|| sItem.extension == '.xlsx')">
                                                                        <img src="../../assets/images/document/excel.png"
                                                                             class="image">
                                                                    </div>
                                                                    <div class="file-left"
                                                                         v-if="sItem.fileType == 8 && (sItem.extension == '.ppt'|| sItem.extension == '.pptx')">
                                                                        <img src="../../assets/images/document/ppt.png"
                                                                             class="image">
                                                                    </div>
                                                                    <div class="file-left"
                                                                         v-if="sItem.fileType == 8 && sItem.extension == '.txt'">
                                                                        <img src="../../assets/images/document/txt.png"
                                                                             class="image">
                                                                    </div>
                                                                    <div class="file-left"
                                                                         v-if="sItem.fileType == 8 && (sItem.extension == '.doc'||sItem.extension == '.docx')">
                                                                        <img src="../../assets/images/document/word.png"
                                                                             class="image">
                                                                    </div>
                                                                    <div class="file-left"
                                                                         v-if="sItem.fileType == 8 && sItem.extension != '.doc'&& sItem.extension != '.docx' && sItem.extension != '.txt' && sItem.extension != '.ppt'&& sItem.extension != '.pptx' && sItem.extension != '.xls' && sItem.extension != '.xlsx' && sItem.extension != '.pdf'">
                                                                        <img src="../../assets/images/document/undefined.png"
                                                                             class="image">
                                                                    </div>
                                                                    <ul class="file-right">
                                                                        <li class="file-right-item">
                                                                            <label>{{$t('c.resourceName')}}：</label><span>{{sItem.reName}}</span>
                                                                        </li>
                                                                        <li class="file-right-item" v-if="sItem.isExist">
                                                                            <div style="width: 100px; height: 60px"
                                                                                 v-loading="true"></div>
                                                                        </li>
                                                                        <li class="file-right-item" v-if="sItem.upFileID > 0">
                                                                            <el-progress :text-inside="true" :stroke-width="13"
                                                                                         :percentage="Math.round(sItem.upProgress*100)"></el-progress>
                                                                        </li>
                                                                        <li class="file-right-item" v-if="sItem.upFileID > 0">
                                                                            <el-button type="mini" @click="endUpload(sItem)"
                                                                                       :disabled="sItem.upProgress == 1" round>
                                                                                {{$t('course.terminateUpload')}}
                                                                            </el-button>
                                                                        </li>
                                                                        <li class="file-right-item is-marquee"
                                                                            v-if="sItem.fileType == 10 && sItem.upFileID == 0">
                                                                            <label>{{$t('course.marquee')}}：</label>
                                                                            <el-switch v-model="sItem.marquee"
                                                                                       activeColor="#22B9FF"
                                                                                       class="marquee-switch"></el-switch>
                                                                            <el-input v-model="sItem.marqueeText"
                                                                                      v-show="sItem.marquee"
                                                                                      :placeholder="$t('course.marqueeText')"
                                                                                      maxLength="30" size="mini"
                                                                                      class="marquee-text"></el-input>
                                                                        </li>
                                                                        <li class="file-right-item"
                                                                            v-if="(sItem.fileType == 10 ||sItem.fileType == 11) && sItem.upFileID == 0">
                                                                            <el-radio v-model="sItem.fastForward" label="1">
                                                                                {{$t('course.fastForward')}}
                                                                            </el-radio>
                                                                            <el-radio v-model="sItem.fastForward" label="0">
                                                                                {{$t('course.noFastForward')}}
                                                                            </el-radio>
                                                                        </li>
                                                                        <li class="file-right-item"
                                                                            v-if="sItem.fileType == 8  && sItem.upFileID == 0">
                                                                            <label>{{$t('course.learningTime')}}：</label>
                                                                            <el-input-number v-model="sItem.duration"
                                                                                             :precision="0"
                                                                                             controls-position="right" :min="0"
                                                                                             :max="1440"
                                                                                             size="mini"></el-input-number>
                                                                            ({{$t('course.min')}})

                                                                        </li>
                                                                        <li class="file-right-item file-des">
                                                                            <label>{{$t('c.description')}}：</label>
                                                                            <el-input type="textarea" v-model="sItem.description" :placeholder="$t('course.sectionDes')"
                                                                                      :autosize="{minRows:2,maxRows: 2}" :maxLength="500"></el-input>
                                                                        </li>

                                                                    </ul>

                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </draggable>
                                        </ul>
                                    </div>
                                </li>
                            </draggable>
                        </ul>

                    </div>
                </div>
                <div id="uploadPanel" style="display: none">
                    <uploader ref="uploader"
                              :options="options"
                              :autoStart="false"
                              @file-added="onFileAdded"
                              @file-progress="onFileProgress"
                              @file-success="onFileSuccess"
                              @file-error="onFileError"
                              class="uploader-example">
                        <uploader-btn id="uploadImage" :attrs="imageAttr">
                            {{$t('course.imageUpload')}}

                        </uploader-btn>
                        <uploader-btn id="uploadText" :attrs="textAttr">
                            {{$t('course.documentUpload')}}

                        </uploader-btn>
                        <uploader-btn id="uploadAudio" :attrs="audioAttr">
                            {{$t('course.audioUpload')}}

                        </uploader-btn>
                        <uploader-btn id="uploadVideo" :attrs="videoAttr">
                            {{$t('course.videoUpload')}}
                        </uploader-btn>
                        <uploader-list>
                            <div class="file-panel" slot-scope="props">
                                <ul class="file-list">
                                    <li v-for="file in props.fileList"
                                        :key="file.id">
                                        <uploader-file :file="file" :list="true" ref="file"></uploader-file>
                                    </li>
                                </ul>
                            </div>
                        </uploader-list>
                    </uploader>
                </div>

                <div class="btn-group">
                    <!--<el-button-group>-->
                    <el-button type="primary" @click="lastStep()"
                               style="margin-right: 20px;padding: 14px 50px;font-size: 18px; ">{{$t('c.prev')}}
                    </el-button>
                    <el-button type="success" @click="finishStep()" :loading="submitLoading" style="padding: 14px 50px;font-size: 18px;">
                        {{$t('c.finish')}}
                    </el-button>
                    <!--</el-button-group>-->
                </div>
            </section>
        </transition>
        <resource-dialog
            :type="dialog.type"
            :dialogOpen="dialog.resourceDialog"
            :initData="dialog.initData"
            @onDialogClosed="dialog.resourceDialog=false"
            @onSelectOver="chooseResOver">
        </resource-dialog>
    </sub-page>
</template>

<script>
    import api from '@/api';
    import {mapGetters} from 'vuex'
    import {Ticket, Cascade} from '@/utils';
    import {ACCEPT_CONFIG} from '@/config/constant';
    import SubPage from '@/components/Subpage';
    import draggable from 'vuedraggable'
    import resourceDialog from '@/components/Dialog/ResourceDialog';
    import SparkMD5 from 'spark-md5';

    export default {
        props: ['courseId'],
        data(){
            return {
                ruleForm: {
                    name: '',
                    knowledge: [],
                    forLevel: '',
                    hours: 0,
                    score: 0,
                    description: '',
                    type: 1,
                    cover: ''
                },
                imageUrl: '',
                active: 0,
                rules: {
                    name: [
                        {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                    ],
                    knowledge: [
                        {required: true, message: this.$t('tip.knowledgePoint'), trigger: 'change'}
                    ],
                    forLevel: [
                        {required: true, message: this.$t('tip.operatorLevel'), trigger: 'change'}
                    ],
                    hours: [
                        {required: true, message: this.$t('tip.hours'), trigger: 'change'}
                    ],
                    score: [
                        {required: true, message: this.$t('tip.credits'), trigger: 'change'}
                    ],
                    description: [
                        {max: 500, message: this.$t('rule.maxLength', ['500']), trigger: 'blur'},
                    ],
                },
                cascadeProp: {
                    value: 'id',
                    label: 'value',
                    children: 'children'
                },
                forLevels: [],
                imageAttr: {accept: ACCEPT_CONFIG.image},
                textAttr: {accept: ACCEPT_CONFIG.document},
                videoAttr: {accept: ACCEPT_CONFIG.video},
                audioAttr: {accept: ACCEPT_CONFIG.audio},
                options: {
                    target: api.simpleUploadURL,
                    chunkSize: '2048000',
                    fileParameterName: 'upfile',
                    testChunks: true,     //是否开启秒传
                    allowDuplicateUploads: true,     //是否允许重复上传
                    maxChunkRetries: 3,
                    //generateUniqueIdentifier:function(){return "987654321"},
                    checkChunkUploadedByResponse: function (chunk, message) {
                        var objMessage = JSON.parse(message);
                        if (objMessage.skipUpload) {
                            return true;
                        }
                        return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0
                    },
                    headers: {
                        Authorization: Ticket.get() && "Bearer " + Ticket.get().access_token
                    },
                },
                chapters: [{
                    "name": "",
                    "isCurrent": true,
                    "sections": [{
                        "isCurrent": true,
                        "name": "",
                        "resourceID": 0,
                        "reName": "",
                        "fileType": 0,
                        "extension": '',
                        "resURL": "",
                        "fastForward": '1',
                        "duration": 0,
                        "isExist": false,//此字段 文件验证重复匹配时显示
                        "upFileID": 0,
                        "upProgress": 0,
                        "description": '',
                    }]
                }],//章节数据
                dialog: {   //资源选择页面
                    resourceDialog: false,
                    initData: {}
                },
                currentChapter: 0,
                currentSection: 0,
                isClickFinish: false,
                imgUpload: {
                    api: api.fileUploadURL + '/Cover',
                    params: {
                        'access_token': Ticket.get().access_token
                    },
                },
                disableUploadCover: false,
                submitLoading: false
            }
        },
        created() {
            this.$store.dispatch('getForLevelMenu');
            this.$store.dispatch('getKnowledgeMenu', {
                type: 'Theory'
            }).then(data => {
                if (this.courseId) this.initData();
            });
        },
        computed: {
            ...mapGetters([
                'forLevelMenu',
                'knowledgeMenu'
            ]),
            uploader() {
                return this.$refs.uploader.uploader
            },
        },
        methods: {
            handleAvatarSuccess(res, file) {
                if (res.result) {
                    this.imageUrl = res.url
                    this.disableUploadCover = true
                } else {
                    this.$message.error(res.message)
                }
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2
                if (!isLt2M) {
                    this.$message.error(this.$t('course.coverTooBigMsg'))
                } else {
                    this.imgUpload.params.access_token = Ticket.get().access_token
                }
                return isLt2M
            },
            deleteCover(){
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    this.imageUrl = ''
                    this.disableUploadCover = false
                }).catch(() => {
                });
            },
            //修改操作 初始化
            initData() {
                api.getTheoryCourseDetail(this.courseId).then(res => {
                    let courseData = res.package
                    this.ruleForm.name = courseData.name
                    this.ruleForm.knowledge = Cascade.fullPath(this.knowledgeMenu['Theory'], courseData.knowledge)
                    this.ruleForm.forLevel = courseData.forLevel
                    this.ruleForm.type = courseData.type
                    this.ruleForm.hours = courseData.hours
                    this.ruleForm.score = courseData.score
                    this.ruleForm.description = courseData.description
                    if (courseData.cover) {
                        this.imageUrl = courseData.cover
                        this.disableUploadCover = true
                    }

                    let chap = []
                    courseData.chapters.forEach((item, index) => {
                        let sect = [];
                        item.sections.forEach((item2, index2) => {
                            let fast
                            item2.fastForward ? fast = '1' : fast = '0'
                            sect.push({
                                "isCurrent": (index2 == 0 ? true : false),
                                "name": item2.name,
                                "resourceID": item2.resourceID,
                                "reName": item2.resource.name,
                                "fileType": item2.type,
                                "extension": item2.resource.extension,
                                "resURL": item2.resource.thumbnail,
                                "fastForward": fast,
                                "duration": item2.duration,
                                "marquee": item2.marquee,
                                "marqueeText": item2.marqueeText,
                                "isExist": false,
                                "upFileID": 0,
                                "upProgress": 0,
                                "description": item2.description
                            })
                        })
                        chap.push({'name': item.name, 'isCurrent': (index == 0 ? true : false), 'sections': sect})
                    })
                    this.chapters = chap
                })
            },
            //点击上传文件
            uploadFiles(type, cIdx, sIdx){
                switch (type) {
                    case 8:
                        $('#uploadText').click()
                        break
                    case 10:
                        $('#uploadVideo').click()
                        break
                    case 11:
                        $('#uploadAudio').click()
                        break
                    case 12:
                        $('#uploadImage').click()
                        break
                }
                this.currentChapter = cIdx
                this.currentSection = sIdx
            },
            //上传
            onFileAdded(file) {
                let item = this.chapters[this.currentChapter].sections[this.currentSection]
                item.upFileID = file.id
                item.reName = file.name
                let rename = file.name
                item.extension = rename.substring(rename.lastIndexOf('.'), rename.length)

                this.computeMD5(file);
            },
            /**
             * 计算md5，实现断点续传及秒传
             * @param file
             */
            computeMD5(file) {
                let fileReader = new FileReader();
                let time = new Date().getTime();
                let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
                let currentChunk = 0;
                const chunkSize = 10 * 1024 * 1000;
                let chunks = Math.ceil(file.size / chunkSize);
                let spark = new SparkMD5.ArrayBuffer();

                // this.statusSet(file.id, 'md5');
                file.pause();

                loadNext();

                fileReader.onload = (e => {
                    spark.append(e.target.result);

                    if (currentChunk < chunks) {
                        currentChunk++;
                        loadNext();

                        this.$nextTick(() => {
                            $(`.myStatus_${file.id}`).text(this.$t('res.checkMD5') +' '+ ((currentChunk/chunks)*100).toFixed(0)+'%')
                        })
                    } else {
                        let md5 = spark.end();
                        this.computeMD5Success(md5, file);
                        console.log(`MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size} 用时：${new Date().getTime() - time} ms`);
                    }
                });

                fileReader.onerror = function () {
                    this.error(`文件${file.name}读取出错，请检查该文件`)
                    file.cancel();
                };

                function loadNext() {
                    let start = currentChunk * chunkSize;
                    let end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;

                    fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
                }
            },

            computeMD5Success(md5, file) {
                // 将自定义参数直接加载uploader实例的opts上
                Object.assign(this.uploader.opts, {
                    query: {
                        culture: this.$i18n.locale,
                        'ui-culture': this.$i18n.locale
                    },
                    headers: {
                        Authorization: Ticket.get() && "Bearer " + Ticket.get().access_token
                    },
                })

                file.uniqueIdentifier = md5;
                file.resume();
            },
            onFileProgress(pro){
                this.chapters.forEach((val, index) => {
                    val.sections.forEach((s, i) => {
                        if (s.upFileID == pro.id) {
                            s.isExist = false
                            s.upProgress = pro._prevProgress
                        }
                    })
                })
            },
            onFileSuccess(rootFile, file, response, chunk) {
                let res = JSON.parse(response)
                if (res.needMerge) {
                    api.mergeSimpleUpload({
                        tempName: res.tempName,
                        fileName: file.name,
                        totalChunks: res.totalChunks
                    }).then(res => {
                        if (res.status === 0) {
                            this.chapters.forEach(item => {
                                item.sections.forEach(item2 => {
                                    if (item2.upFileID == file.id) {
                                        item2.upFileID = 0
                                        item2.isExist = false
                                        item2.upProgress = 0
                                        item2.resourceID = res.resourceID
                                        item2.resURL = res.url
                                        item2.marquee = false
                                        item2.marqueeText = ""
                                        item2.description = ""
                                    }
                                })
                            })
                        } else if (res.status === 1) {
                            console.log('上传失败')
                        } else if (res.status === 2) {
                            this.chapters.forEach(item => {
                                item.sections.forEach(item2 => {
                                    if (item2.upFileID == file.id) {
                                        item2.upFileID = 0
                                        item2.isExist = false
                                        item2.upProgress = 0
                                        item2.resourceID = res.resourceID
                                        item2.resURL = res.url
                                        item2.marquee = false
                                        item2.marqueeText = ""
                                        item2.description = ""
                                    }
                                })
                            })
                        }
                    });
                } else {
                    this.chapters.forEach(item => {
                        item.sections.forEach(item2 => {
                            if (item2.upFileID == file.id) {
                                item2.upFileID = 0
                                item2.isExist = false
                                item2.upProgress = 0
                                item2.resourceID = res.resourceID
                                item2.resURL = res.url
                                item2.marquee = false
                                item2.marqueeText = ""
                                item2.description = ""
                            }
                        })
                    })
                }
            },
            onFileError(rootFile, file, response, chunk) {
                this.$message({
                    message: this.$t('course.fileUploadFail'),
                    type: 'error'
                })
            },
            //下一步
            next(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.active++
                    } else {
                        return false
                    }
                });
            },
            //上一步
            lastStep() {
                this.active--
            },
            //点击步骤
            on_click(e){
                if (e == 1) {
                    if (this.$refs.ruleForm) {
                        this.$refs.ruleForm.validate((valid) => {
                            if (valid) {
                                this.active = e
                            } else {
                                return false
                            }
                        });
                    } else {
                        this.active = e
                    }
                } else {
                    this.active = e
                }
            },
            //保存课件
            finishStep(){
                this.isClickFinish = true
                //第二步验证
                if (this.validateChapter()) {
                    return
                } else {
                    //保存数据
                    let chapterArray = []
                    this.chapters.forEach((item, index1) => {
                        let sectionArray = []
                        item.sections.forEach((item2, index2) => {
                            if (item2.fastForward == 1) {
                                item2.fastForward = true
                            } else {
                                item2.fastForward = false
                            }
                            sectionArray.push({
                                "order": index2 + 1,
                                "name": item2.name,
                                "resourceID": item2.resourceID,
                                "reName": item2.reName,
                                "fileType": item2.type,
                                "resURL": item2.resURL,
                                "fastForward": item2.fastForward,
                                "duration": item2.duration,
                                "marquee": item2.marquee,
                                "marqueeText": item2.marqueeText,
                                "description": item2.description
                            })
                        })
                        chapterArray.push({
                            "name": item.name,
                            "order": index1 + 1,
                            "sections": sectionArray
                        })
                    })
                    let kpoint
                    this.ruleForm.knowledge.length == 1 ? kpoint = this.ruleForm.knowledge[0] : kpoint = this.ruleForm.knowledge[1]
                    let submitData = {
                        'name': this.ruleForm.name,
                        'forLevel': this.ruleForm.forLevel,
                        'knowledge': kpoint,
                        'type': this.ruleForm.type,
                        'hours': this.ruleForm.hours,
                        'score': this.ruleForm.score,
                        'description': this.ruleForm.description,
                        'cover': this.imageUrl,
                        "chapters": chapterArray
                    }
                    this.submitLoading = true
                    if (this.courseId) {
                        api.putTheoryCourse(this.courseId, submitData).then(res => {
                            this.submitLoading = false;
                            this.$notify({
                                title: res.error,
                                message: this.$t('course.courseEditSuccess'),
                                type: 'success',
                                duration: 2000
                            });
                            this.$emit('needUpdate');
                            this.$router.replace({name: 'myCourse'})
                        }).catch(error => this.submitLoading = false)

                    } else {
                        api.postTheoryCourse(submitData).then(res => {
                            this.submitLoading = false;
                            this.$notify({
                                title: res.error,
                                message: this.$t('course.courseMakeSuccess'),
                                type: 'success',
                                duration: 2000
                            });
                            this.isClickFinish = false
                            this.$emit('needUpdate');
                            this.$router.replace({name: 'myCourse'})
                        }).catch(error => this.submitLoading = false)
                    }
                }
            },
            //知识点变化
            knowledgeChange(data){
                this.ruleForm.knowledge = data
            },

            //点击资源选择
            chooseRes(type, cIndex, sIndex) {
                this.currentChapter = cIndex
                this.currentSection = sIndex
                this.dialog.type = type
                this.dialog.resourceDialog = true
            },
            //选择资源完毕
            chooseResOver(data){
                if (data.length > 0) {
                    let item = this.chapters[this.currentChapter].sections[this.currentSection]
                    item.resourceID = data[0].id
                    item.reName = data[0].name
                    item.extension = data[0].extension
                    if (data[0].type == 12) {
                        item.resURL = data[0].thumbnail
                    }
                }
            },
            //删除资源选择文件
            deleteFile(item){
                item.resourceID = 0
                item.reName = ''
                item.resURL = ''
                item.fastForward = '1'
                item.duration = 0
                item.marquee = false
                item.marqueeText = ''
                item.description = ''
            },
            //添加章
            addChapter(index){
                this.chapters.forEach(item => {
                    item.isCurrent = false
                    item.sections.forEach(item2 => {
                        item2.isCurrent = false
                    })
                })
                let chapter = {
                    "name": "",
                    "isCurrent": true,
                    "sections": [{
                        "isCurrent": true,
                        "name": "",
                        "resourceID": 0,
                        "reName": "",
                        "fileType": 0,
                        "extension": '',
                        "resURL": "",
                        "fastForward": '1',
                        "duration": 0,
                        "isExist": false,
                        "upFileID": 0,
                        "upProgress": 0,
                        "marquee": false,
                        "marqueeText": "",
                        "description": ""
                    }]
                }
                this.chapters.splice(index + 1, 0, chapter)
                this.$nextTick(() => {
                    $('.chapter-current').find("input[name='chapter-name']").focus()
                })
            },
            //添加节
            addSection(cIdx, sIdx){
                this.chapters.forEach(item => {
                    item.sections.forEach(item2 => {
                        item2.isCurrent = false
                    })
                })
                let section = {
                    "isCurrent": true,
                    "name": "",
                    "resourceID": 0,
                    "reName": "",
                    "fileType": 0,
                    "extension": '',
                    "resURL": "",
                    "fastForward": '1',
                    "duration": 0,
                    "isExist": false,
                    "upFileID": 0,
                    "upProgress": 0,
                    "marquee": false,
                    "marqueeText": "",
                    "description": ""
                }
                this.chapters.forEach((item, index) => {
                    if (index == cIdx) {
                        item.sections.splice(sIdx + 1, 0, section)
                    }
                })
                this.$nextTick(() => {
                    $('.section-current').find("input[name='section-name']").focus()
                })
            },
            //删除节
            deleteSection(cIdx, sIdx){
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    this.chapters.forEach((item, index) => {
                        if (index == cIdx) {
                            item.sections.splice(sIdx, 1)
                        }
                    })
                }).catch(() => {
                });
            },
            //删除章
            deleteChapter(cIdx){
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    this.chapters.splice(cIdx, 1)
                }).catch(() => {
                });
            },
            //验证章
            isShowError(item){
                let flag = false;
                if (this.isClickFinish) {
                    if (item.name == '') {
                        flag = true
                    }
                    item.sections.forEach(item2 => {
                        if (item2.resourceID == 0 || item2.name == '') {
                            flag = true
                        }
                    })
                }
                return flag
            },

            clickSecValidate(){
                //console.log('点击节验证')
            },
            //第二步章节验证
            validateChapter(){
                let flag = false;
                this.chapters.forEach(item => {
                    if (item.name == '') {
                        flag = true
                    }
                    item.sections.forEach(item2 => {
                        if (item2.resourceID == 0 || item2.name == '') {
                            flag = true
                        }
                    })
                })
                return flag
            },

            //点击章展开收起
            clickChapterFold(flag, index){
                this.chapters.forEach((item, idx) => {
                    if (idx == index) {
                        if (flag) {
                            item.isCurrent = false
                            item.sections.forEach(item2 => {
                                item2.isCurrent = false
                            })
                        } else {
                            item.isCurrent = true
                        }
                    } else {
                        item.isCurrent = false
                        item.sections.forEach(item2 => {
                            item2.isCurrent = false
                        })
                    }
                })
            },
            //点击节展开收起
            clickSectionFold(flag, cIdx, sIdx){
                this.chapters.forEach((item, idx1) => {
                    if (idx1 == cIdx) {
                        item.sections.forEach((item2, idx2) => {
                            if (sIdx == idx2) {
                                if (flag) {
                                    item2.isCurrent = false
                                } else {
                                    item2.isCurrent = true
                                }
                            } else {
                                item2.isCurrent = false
                            }
                        })
                    }
                })
            },
            //终止上传
            endUpload(sItem){
                let fileList = this.$refs.file
                let idx = 0
                fileList.forEach((item, index) => {
                    if (item.file.id == sItem.upFileID) {
                        idx = index
                        item.file.cancel()
                        sItem.resourceID = 0
                        sItem.reName = ''
                        sItem.resURL = ''
                        sItem.fastForward = '1'
                        sItem.duration = 0
                        sItem.upFileID = 0
                        sItem.marquee = false
                        sItem.marqueeText = ''
                        sItem.description = ''
                    }
                })
            },
            closeFn() {
                if (this.courseId) {
                    this.$router.replace({name: 'myCourse'})
                    return
                }

                this.$confirm(this.$t('m.coursingOrExit'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    this.$router.replace({name: 'myCourse'})
                }).catch(() => {
                });
            },
            success(msg) {
                this.$message({
                    message: msg,
                    type: 'success'
                })
            },
        },
        destroyed() {
            this.$emit('onClose')
        },
        components: {
            SubPage,
            resourceDialog,
            draggable,
        }

    }
</script>
<style lang="scss">
    .m-addTheoryCourse {
        .course-form {
            .el-form-item__content {
                > .el-input,
                > .el-cascader,
                > .el-input-number,
                > .el-select {
                    width: 70%;
                    min-width: 220px;
                }
            }
            @media screen and (max-width: 1280px) {
                .el-col {
                    float: none;
                    width: 75%;
                }
            }
        }
        .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }

        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 220px;
            height: 178px;
            line-height: 178px;
            text-align: center;
        }

        .mask {
            position: absolute;
            left: 0;
            bottom: 0;
            right: 0;
            background-color: #000;
            opacity: 0.6;
            transition: all .3s ease-in-out;
            text-align: right;
            padding-right: 20px;
            color: #fff;
            height: 40px;
            &:hover {
                i {
                    font-size: 18px;
                }
            }
        }
        .el-upload__tip {
            margin-top: -5px;
        }
    }

    .myCoursePage {
        .sub-page .box-card {
            min-height: 98%;
        }
        .step-box .btn-group {
            text-align: center;
        }
    }

    .app-root:not(.lang-zh-CN) {
        .m-addTheoryCourse {
            .course-form {
                margin-left: 40px;
                .el-col {
                    float: none;
                    width: 75%;
                    max-width: 800px;
                }
            }
        }
    }
</style>

<style lang="scss" scoped>
    .picture-upload {
        width: 100%;
        height: 100%;
        border: 1px dashed #d9d9d9;
        border-radius: 3px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        text-align: center;
        i {
            font-size: 28px;
            color: #999;
            line-height: 175px;
        }
    }

    .btn-group {
        margin-top: 15px;
        text-align: center;
    }

    .marBtm15 {
        margin-bottom: 15px;
    }

    .el-step {
        cursor: pointer;
    }

    .chapter-section {
        padding: 10px 30px 20px;
    }

    .chapter-section-panel {
        border: 1px solid #ccc;
        padding-bottom: 10px;
        .panel-heading {
            display: flex;
            height: 38px;
            line-height: 38px;
            background-color: #f5f7fa;
            border-bottom: 1px solid #ccc;
            .course-file-icon {
                height: 38px;
                width: 45px;
                line-height: 38px;
                text-align: center;
                border-right: 1px solid #ccc;
                color: #1987cb;
                margin-right: 15px;
                i {
                    font-size: 22px;
                }
            }
            .title {
                font-size: 16px;
            }
            .chapter-add-tip {
                color: #999;
                padding-left: 20px;
            }

        }
        .panel-body {
            padding: 10px;
            min-height: calc(54vh);
            .chapter-content {
                cursor: move;
                border: 1px solid #ccc;
                border-bottom: none;
                border-radius: 1px;
                &.chapter-current {
                    border-color: #999;
                    margin-bottom: 10px;
                    border-bottom: 1px solid #999;
                }
                &:last-child {
                    border-bottom: 1px solid #ccc;
                }
                .section-content {
                    cursor: move;
                    border: 1px solid #ccc;
                    border-bottom: none;
                    border-radius: 1px;
                    &.section-current {
                        border-color: #999;
                        margin-bottom: 10px;
                        border-bottom: 1px solid #999;
                    }
                    &:last-child {
                        border-bottom: 1px solid #ccc;
                    }
                    .section-content-type {
                        padding: 10px;
                        min-height: 185px;
                    }
                }

            }
        }
    }

    .section-file-type {
        display: flex;
        padding-top: 15px;
        .file-type {
            width: 110px;
            border: 9px solid rgba(52, 52, 52, 0.15);
            height: 110px;
            text-align: center;
            border-radius: 5px;
            padding-top: 20px;
            margin: 5px 30px;
            cursor: pointer;
            &:hover {
                border-width: 10px;
                color: #1b6b83;
                font-size: 14px;
                i {
                    font-size: 32px;
                }
            }
            i {
                font-size: 30px;
            }
            p {
                padding-top: 5px;
            }
        }

    }

    .chapter-section-header {
        display: flex;
        justify-content: space-between;
        height: 42px;
        line-height: 42px;
        background: linear-gradient(#fafafa, #eeeeee);
        .header-input {
            width: 450px;
            display: flex;
            &.section {
                width: 420px;
                .num {
                    padding-left: 15px;
                }
                .section-drag {
                    width: 42px;
                    text-align: center;
                    color: #fff;
                    background: linear-gradient(#eaeaea, #d9d9d9);
                    border-right: #b2b2b2;
                    cursor: move;
                    i {
                        font-size: 24px;
                    }
                }
            }
            .num {
                padding-right: 5px;
                padding-left: 18px;
            }
        }
        .header-operate {
            margin-right: 20px;
            display: flex;
            i {
                margin-right: 20px;
                color: #999;
                cursor: pointer;
                &.error-tip {
                    cursor: default;
                    color: #ff4081;
                }
            }

        }
    }

    .file-select-operate {
        padding-bottom: 3px;
        border-bottom: 1px dashed #ccc;
        display: flex;
        .el-button:nth-child(2) {
            margin: 0 30px;
        }
    }

    .file-selected-wrap {
        padding-left: 60px;
        padding-top: 15px;
        .file-resource {
            display: flex;
            .delete-file{
                color: #ff4081;
                cursor: pointer;
            }
            .file-left {
                width: 100px;
                height: 100px;
                img {
                    height: 100%;
                    width: 100%;
                }
            }
            .file-right {
                margin-left: 25px;
                .file-right-item {
                    margin-bottom: 3px;
                    line-height: 28px;
                    &:first-child {
                        font-size: 14px;
                    }
                    &.is-marquee {
                        display: flex;

                        .marquee-switch {
                            height: 28px;
                            line-height: 28px;
                        }
                        .marquee-text {
                            width: 250px;
                            margin-left: 30px;
                        }
                    }
                    &.file-des{
                        display: flex;
                        width: 350px;
                        margin-top: 10px;
                        >label{
                            white-space: nowrap;
                        }
                    }
                }
            }
        }
    }

    .uploader-btn {
        position: relative;
        padding: 0;
        font-size: 100%;
        line-height: 1;
        color: #666;
        border: none;
        cursor: pointer;
        border-radius: 2px;
        background: none;
        outline: none;
    }

    .uploader-btn:hover {
        background-color: rgba(0, 0, 0, .08);
    }

    .course-form {
        padding-top: 25px;
    }

    .el-select-dropdown__item {
        width: 220px;
    }

    .avatar {
        width: 238px;
        height: 178px;
        display: block;
    }
</style>
